import { ReactNode } from 'react';
import useScheduledContent, { DateRange } from '../hooks/useScheduledContent';

type ScheduledContentProps = {
  dateRanges: DateRange[];
  children: ReactNode;
};

const ScheduledContent = ({ dateRanges, children }: ScheduledContentProps) => {
  const { dateIsInRange } = useScheduledContent(dateRanges);

  if (dateIsInRange) {
    return children;
  }

  return null;
};

export default ScheduledContent;
